// Material UI components
import React, { Component } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import { useState } from 'react';
import AppBarHome from './appbarhome';

import axios from 'axios';

import { ThemeProvider, createTheme } from '@mui/material/styles';
import App from '../App';
const darkTheme = createTheme({
    palette: {
      mode: 'dark',
    },
  });
  

// login.js

const styles = (theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: '100%',
		marginTop: theme.spacing(1)
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
	customError: {
		color: 'red',
		fontSize: '0.8rem',
		marginTop: 10
	},
	progess: {
		position: 'absolute'
	}
});


function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(false);

	const handleChangeEmail = (event) => {

		setEmail(event.target.value);
	};

    const handleChangePassword = (event) => {

		setPassword(event.target.value);
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		setLoading(true);
		const userData = {
			email: email,
			password: password
		};
		axios
			.post('http://localhost:5000/how-long-65d53/us-central1/api/login', userData)
			.then((response) => {
				localStorage.setItem('AuthToken', `Bearer ${response.data.token}`);
				setLoading(false);	
			})
			.catch((error) => {		
                setErrors(error.response.data);
                alert(errors);
                setLoading(false);		
			});
	};

		return (
            <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <AppBarHome />
			<Container component="main" maxWidth="xs">
				<CssBaseline />
				<div>
					<Typography component="h1" variant="h5">
						Login
					</Typography>
					<form noValidate>
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							id="email"
							label="Email Address"
							name="email"
							autoComplete="email"
							autoFocus
							onChange={handleChangeEmail}
						/>
						<TextField
							variant="outlined"
							margin="normal"
							required
							fullWidth
							name="password"
							label="Password"
							type="password"
							id="password"
							autoComplete="current-password"
							onChange={handleChangePassword}
						/>
						<Button
							type="submit"
							fullWidth
							variant="contained"
							color="primary"
							onClick={handleSubmit}
							disabled={loading || !email|| !password}
						>
							Sign In
							{loading && <CircularProgress size={30}  />}
						</Button>
						<Grid container>
							<Grid item>
								{"Send us a request to sign you up."}
							</Grid>
						</Grid>
					</form>
				</div>
			</Container>
            </ThemeProvider>
		);
	}

export default Login;
